export const preproduction = {
  SECURED_ROOT_SUBDOMAIN: 'pre.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'pre.',
  GIGYA_API_KEY: '3_jQP8pKS0Tu_bWPupkyDOnXwE5htfb4cIqory1wQ-IBJv11CWdQwhzzXIINEyIlo1', // pre.coches.net
  ADYEN_ORIGIN_KEY:
    'pub.v2.8015614668370377.aHR0cHM6Ly9wcmUuY29jaGVzLm5ldA.OD3PjpKaPlTGZ_jMX2YtABAW4LBAFIOguGKty4yoLCg', // https://pre.coches.net
  GOOGLE_AUTH_API_KEY: '200592347366-rjpc0ak4dc44fjtbk2krs9b6roc5jr2v.apps.googleusercontent.com', // https://pre.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const production = {
  SECURED_ROOT_SUBDOMAIN: 'www.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'www.',
  GIGYA_API_KEY: '3_ejKPtiTCoMZOmiD2PJgl0GYbIQOdeBma77joBheqTs15Nx5EkD9evJSOuefj2S6H', // prod.coches.net
  ADYEN_ORIGIN_KEY:
    'pub.v2.1115683755203829.aHR0cHM6Ly93d3cuY29jaGVzLm5ldA.SnveBqK3TW2uwvBHqR927IlmKzNlFxm0rLCLsSbo1rE', // https://www.coches.net
  GOOGLE_AUTH_API_KEY: '200592347366-e1il5gmjhvq70s7d3t3t1e9q1088foq6.apps.googleusercontent.com', // https://www.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const test = {
  SECURED_ROOT_SUBDOMAIN: 'pre.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'test.',
  GIGYA_API_KEY: '3_jQP8pKS0Tu_bWPupkyDOnXwE5htfb4cIqory1wQ-IBJv11CWdQwhzzXIINEyIlo1', // parent.dev.coches.net
  ADYEN_ORIGIN_KEY: 'pub.v2.8015614668370377.aHR0cDovL2xvY2FsaG9zdDozMDAw.DFqmNyWY-Bgj4wUxBRvmch_yayZhEK22dn1gXWmyEpI', // http://localhost:3000
  GOOGLE_AUTH_API_KEY: '200592347366-rjpc0ak4dc44fjtbk2krs9b6roc5jr2v.apps.googleusercontent.com', // http://localhost:3000
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const development = {
  SECURED_ROOT_SUBDOMAIN: 'pre.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'dev.',
  GIGYA_API_KEY: '3_jQP8pKS0Tu_bWPupkyDOnXwE5htfb4cIqory1wQ-IBJv11CWdQwhzzXIINEyIlo1', // pre.coches.net
  ADYEN_ORIGIN_KEY: 'pub.v2.8015614668370377.aHR0cDovL2xvY2FsaG9zdDozMDAw.DFqmNyWY-Bgj4wUxBRvmch_yayZhEK22dn1gXWmyEpI', // http://localhost:3000
  GOOGLE_AUTH_API_KEY: '200592347366-rjpc0ak4dc44fjtbk2krs9b6roc5jr2v.apps.googleusercontent.com', // https://dev.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}
